<template>
  <div class="floatingBox">
    <div class="floating1" v-if="!showType" @click.stop="tabShowType()">
      <img class="_gif" src="../assets/111.gif" alt="">
      <div class="_cont">
        <img src="../assets/kefu1.png" alt="">
        <p>咨</p>
        <p>询</p>
        <p>·</p>
        <p>合</p>
        <p>作</p>
      </div>
    </div>
    <div class="floating2" v-if="showType">
      <div class="_left" @click.stop="tabShowType()">
        <img src="../assets/kefu1.png" alt="">
        <p>咨</p>
        <p>询</p>
        <p>·</p>
        <p>合</p>
        <p>作</p>
      </div>
      <div class="_right">
        <div class="_li">
          <p class="_phone">售前咨询、渠道咨询、大客户合作TEL：{{pageData.phone}}（微信钉钉同号）</p>
          <p style="margin-bottom: 15px;"></p>
        </div>
        <div class="_li ImgBox">
          <div class="_Customer">
            <div class="_p">客服微信</div>
          </div>
          <img :src="pageData.wx_qrcode" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  data(){
    return {
      showType:false,
      pageData: {}
    }
  },
  computed:{
    floatingType(){
      return this.$store.state.floatingType
    }
  },
  watch:{
    'floatingType':{
			handler(value){
				this.showType = value
			},
			immediate: true,
			deep: true 
		}
  },
  mounted() {
    this.getPageData()
  },
  methods:{
    tabShowType(){
      this.showType = !this.showType
      this.$store.commit("setfloatingType", this.showType);
    },
    open(type){
      if(type == 1){
        window.open('http://wpa.qq.com/msgrd?v=3&uin=940423831&site=qq&menu=yes')
      }else if(type == 2){
        window.open('http://wpa.qq.com/msgrd?v=3&uin=2430809233&site=qq&menu=yes')
      }
    },
    getPageData() {
      request({
				method: 'get', 
				url: Apis.getAboutUs,
				params:{},
        _type:1
			}).then(res => {
        this.pageData = res.data
        this.$store.commit("savePageData", res.data);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.floatingBox{
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  .floating1{
    width: 123px;
    height: 210px;
    cursor: pointer;
    display: flex;
    align-items: center;
    ._gif{
      width: 58px;
      height: 58px;
    }
    ._cont{
      width: 65px;
      height: 210px;
      background: #208EFF;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      img{
        width: 40px;
        height: 40px;
      }
      p{
        display: inline-block;
        width: 40px;
        color: #fff;
      }
    }
  }
  .floating2{
    width: 465px;
    height: 395px;
    display: flex;
    ._left{
      width: 65px;
      height: 210px;
      background: #208EFF;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      cursor: pointer;
      margin-top: 20px;
      img{
        width: 40px;
        height: 40px;
      }
      p{
        display: inline-block;
        width: 40px;
        color: #fff;
      }
    }
    ._right{
      width: 400px;
      height: 250px;
      // height: 395px;
      background: #fff;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      border-left: 1px solid #ccc;
      padding: 10px;
      ._li{
        margin: 9px 0;
        width: 100%;
        p{
          color: #5f5f5f;
          line-height: 30px;
          margin-left: 35px;
          position: relative;
          span {
            display: inline-block;
            background: #51B3FF;
            padding: 1px 20px;
            border-radius: 5px;
            margin-right: 10px;
            color: #fff;
          }
          span::before {
            content: '';
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(../assets/QQ.png) no-repeat;
            background-size: 100%;
            position: relative;
            top: 4px;
            right: 5px;
          }
        }
        ._qq::before {
          content: '';
          display: inline-block;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: #51B3FF;
          background: url(../assets/Q11.png) no-repeat;
          background-size: 100%;
          position: absolute;
          top: 2px;
          left: -20px;
        }
        ._phone::before {
          content: '';
          display: inline-block;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: #51B3FF;
          background: url(../assets/Q22.png) no-repeat;
          background-size: 100%;
          position: absolute;
          top: 2px;
          left: -20px;
        }
        ._cooper::before {
          content: '';
          display: inline-block;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: #51B3FF;
          background: url(../assets/Q33.png) no-repeat;
          background-size: 100%;
          position: absolute;
          top: 2px;
          left: -20px;
        }
      }
      .ImgBox{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        ._Customer{
          ._p{
            width: 80px;
            font-size: 20px;
            font-weight: bold;
            line-height: 40px;
            text-align: center;
            // color: #51B3FF;
          }
          ._p2{
            // width: 80px;
            display: flex;
            flex-wrap: wrap;
            span:nth-child(2){
              margin-left:15px;
            }
          }
          // span:nth-child(1){
          //   // width: 40px;
          //   margin-right: 10px;
          // }
        }
        img {
          width: 115px;
          height: 120px;
          margin: 0 auto;
        }
        img:nth-child(1) {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>